import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Spin } from 'antd';
import { ShoppingOutlined, UserOutlined, DollarOutlined } from '@ant-design/icons';
import { getProducts } from '../../services/productService';

const Dashboard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [totalProducts, setTotalProducts] = useState(0);

  useEffect(() => {
    fetchTotalProducts();
  }, []);

  const fetchTotalProducts = async () => {
    try {
      setLoading(true);
      const data = await getProducts({
        page: 1,
        pageSize: 1,
        category: 'all'
      });
      setTotalProducts(data.totalProducts || 0);
    } catch (error) {
      console.error('获取商品总数失败:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <h2>仪表盘</h2>
      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              title="总商品数"
              value={totalProducts}
              prefix={<ShoppingOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="用户数量"
              value={892}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="总销售额"
              value={234567}
              prefix={<DollarOutlined />}
              suffix="¥"
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: '24px' }}>
        <Col span={12}>
          <Card title="最近订单">
            {/* 这里添加订单列表组件 */}
            <p>暂无数据</p>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="热门商品">
            {/* 这里添加热门商品组件 */}
            <p>暂无数据</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
